import { ApplicationRef, ComponentRef, createComponent, inject, Injectable, Injector, Type } from '@angular/core';
import { ComponentPortal } from '@angular/cdk/portal';
import { SidePanelHostComponent } from '../../shared/components/side-panel-host/side-panel-host.component';
import { SidePanelRef } from '../models/side-panel/side-panel-ref';

@Injectable({ providedIn: 'root' })
export class SidePanelService {
  private appRef = inject(ApplicationRef);
  private injector = inject(Injector);

  private currentSidePanelRef: SidePanelRef | null = null;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  open<T, R = any>(component: Type<T>, injector?: Injector): { ref: SidePanelRef<R>; content: ComponentRef<T> } {
    const containerRef = createComponent(SidePanelHostComponent, {
      environmentInjector: this.appRef.injector,
    });

    const sidePanelRef = new SidePanelRef<R>((result?: R) => {
      containerRef.instance.close(result);
    });

    const portal = new ComponentPortal(component, null, injector ?? this.injector);
    containerRef.instance.attachPortal(portal);

    this.appRef.attachView(containerRef.hostView);
    document.body.appendChild(containerRef.location.nativeElement);

    containerRef.instance.closed.subscribe((result?: R) => {
      this.appRef.detachView(containerRef.hostView);
      containerRef.destroy();
      sidePanelRef.emitClosed(result);
      this.currentSidePanelRef = null;
    });

    this.currentSidePanelRef = sidePanelRef;
    const contentRef = containerRef.instance.portalOutlet()?.attachedRef as ComponentRef<T>;
    return { ref: sidePanelRef, content: contentRef };
  }

  sidePanelRef(): SidePanelRef | null {
    return this.currentSidePanelRef;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  close(result?: any) {
    this.sidePanelRef()?.close(result);
  }
}
